import styles from './index.module.scss'
import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react'
import eventBus from "@utils/eventBus";
import { Button, Dropdown, Slider, Space, Switch, message } from "antd"
import Iconfont from '@utils/Iconfont';
import { useNavigate } from "react-router";
import PSAIModal from '@PSAIComponents/PSAIModal';
import { GENERATE_MODE, BATCH_IMAGES_TYPE } from "@utils/CONST"
import Utils from '@utils/utils';
import API from "@api/api";
import { UPLOAD_SOURCE, RESOLUTION_ALIGN } from "@utils/CONST"

const modeItems = [{
    value: GENERATE_MODE.STD,
    title: "标准模式",
    content: "生成速度更快",
    icon: <Iconfont type="icon-stdOutlined" />,
    iconActive: <Iconfont type="icon-stdFilled" />,
}, {
    value: GENERATE_MODE.HQ,
    title: "高品质模式",
    content: "生成效果更好",
    icon: <Iconfont type="icon-hdOutlined" />,
    iconActive: <Iconfont type="icon-hdFilled" />,
    // isLimit: true,
}]

const resolutionAlignItems = [{
    value: RESOLUTION_ALIGN.INPUT,
    title: "上传图比例",
    content: "按上传图比例生成",
}, {
    value: RESOLUTION_ALIGN.BKG,
    title: "参考图比例",
    content: "按已选背景参考图比例",
}]

const FooterBar = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        handleBatchExit
    }))
    const navigate = useNavigate()
    const {
        projectType,
        uploading,
        selectedRowKeys,
        selectedRows,
        onAddMore,
        skuNumber,
        projectId,
        isEdit,
        dataSource,
        setDataSource
    } = props
    const [batchMode, setBatchMode] = useState()
    const [submitConfigVisible, setSubmitConfigVisible] = useState(false)
    const [handleNumber, setHandleNumber] = useState(4)
    const [generateMode, setGenerateMode] = useState(GENERATE_MODE.STD)
    const [resolutionAlign, setResolutionAlign] = useState(RESOLUTION_ALIGN.INPUT)
    const [switchChecked, setSwitchChecked] = useState(false)
    const [switchChecked2, setSwitchChecked2] = useState(false)
    const [relight, setRelight] = useState(0.0)
    const [loading, setLoading] = useState(false)
    const [createLoading, setCreateLoading] = useState(false)
    const [total, setTotal] = useState(0)

    const handleBatchClick = ({ key }) => {
        console.log('key', key)
        setBatchMode(key)
        props.getBatchMode(key)
        props.setShowSelectionColumn(true)
    }
    const handleBatchExit = () => {
        setBatchMode()
        props.setShowSelectionColumn(false)
        props.setSelectedRowKeys([])
        props.setSelectedRows([])
    }

    // 暴露handleBatchExit方法给父组件
    useImperativeHandle(ref, () => ({
        handleBatchExit
    }))

    const handleBatchSubmit = async () => {
        if (batchMode == 'appendTop' || batchMode == 'appendBottom') {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/jpeg,image/png,image/webp,image/avif';
            input.onchange = async (e) => {
                try {
                    let file = e.target.files[0];
                    if (file) {
                        setLoading(true)
                        // 检查文件类型和宽高比
                        const isNromal = await Utils.validateImageFile(file)
                        if (!isNromal) return
                        // resize图片
                        const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
                        console.log('resizeRes', resizeRes)
                        if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message) }
                        file = resizeRes.file
                        // 上传图片
                        const legalRes = await Utils.checkImageIslegal(file, 0, UPLOAD_SOURCE.SERVICE)
                        if (!legalRes || !legalRes.isLegal) { message.warning(legalRes?.message); return; }

                        // 检测上传图类型
                        const clothType = await API.getClothType({ imageUrl: legalRes?.data })
                        const clothTextList = ['上装', '下装', null, '裙装']
                        if ((clothType?.data === 0 && batchMode == 'appendTop') || (clothType?.data === 1 && batchMode == 'appendBottom')) {
                            saveUploadImg(legalRes.data)
                        } else {
                            PSAIModal.confirm({
                                title: `系统检测到您上传的图片可能是${clothTextList[clothType.data]}`,
                                okText: "继续填入",
                                cancelText: `取消上传`,
                                onOk() {
                                    saveUploadImg(legalRes.data)
                                },
                                onCancel() {
                                    setLoading(false)
                                }
                            })
                        }
                    }
                } catch (error) {
                    setLoading(false)
                }
            }
            input.click();
        } else if (batchMode == 'appendModel') {
            props.openReferenceDrawer([], projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? 1 : 10, {}, BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH)
        } else if (batchMode == 'appendBkg') {
            props.openReferenceDrawer([], 10, {}, BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH)
        } else if (batchMode == 'appendTryon') {
            props.openReferenceDrawer([], 10, {}, BATCH_IMAGES_TYPE.TRYON_BATCH)
        } else if (batchMode == 'appendCommodityStacking') {
            props.openReferenceDrawer([], 10, {}, BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH)
        } else if (batchMode == 'delete') {
            props.handleRemove(selectedRows.map(item => item.skuId))
        }
    }
    const saveUploadImg = async (url) => {
        const updatedRows = selectedRows.map(item => {
            const newInputImages = [...item.inputImages];
            const nonMainIndex = newInputImages.findIndex(img => img.mainImage === false);

            if (nonMainIndex !== -1) {
                newInputImages[nonMainIndex] = {
                    ...newInputImages[nonMainIndex],
                    url,
                };
            } else {
                newInputImages.push({
                    mainImage: false,
                    url,
                });
            }

            return {
                ...item,
                projectId,
                inputImages: newInputImages,
            };
        });

        console.log("更新后的 selectedRows:", updatedRows);
        const saveRes = await API.batchSaveSku(updatedRows)
        if (saveRes?.code === 0) {
            props.listSkuByProject()
            handleBatchExit()
            setLoading(false)
        }
    };

    // 批量操作
    const items = useMemo(() => {
        console.log('projectType', projectType)
        if (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH) {
            return [
                { key: "appendTop", label: "批量添加上装" },
                { key: "appendBottom", label: "批量添加下装" },
                { key: "appendModel", label: "设置模特图" },
                { key: "appendTryon", label: "设置模试衣参考图" },
                { key: "delete", label: "批量删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH) {
            return [
                { key: "appendModel", label: "设置模特图" },
                { key: "delete", label: "批量删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) {
            return [
                { key: "appendBkg", label: "设置背景图" },
                { key: "delete", label: "批量删除" },
            ]
        } else if (projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH) {
            return [
                { key: "appendCommodityStacking", label: "设置辅品图" },
                { key: "delete", label: "批量删除" },
            ]
        }
    }, [projectType])


    const handleSubmitConfig = async () => {
        if (isEdit) {
            editAndGenerate()
            return
        }
        if (dataSource.length === 0) {
            message.error('请先添加商品')
            return
        }
        setCreateLoading(true)
        console.log('handleNumber', handleNumber, 'generateMode', generateMode, 'switchChecked', switchChecked)
        // 检测未选参考图的sku
        const processedDataSource = dataSource.map(item => {
            // 创建新对象以避免直接修改原始数据
            const newItem = { ...item };

            // 根据projectType检查对应的数组长度
            if (projectType === BATCH_IMAGES_TYPE.TRYON_BATCH && (!item.refList || item.refList.length === 0)) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH && (!item.modelList || item.modelList.length === 0)) {
                newItem.error = true;
            } else if (projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH && (!item.bkgList || item.bkgList.length === 0)) {
                newItem.error = true;
            } else {
                newItem.error = false;
            }

            return newItem;
        });
        console.log('dataSource', dataSource)
        console.log('processedDataSource', processedDataSource)
        setDataSource(processedDataSource)

        // 检查是否有任何项设置了error = true
        const hasErrorItems = processedDataSource.some(item => item.error === true);

        if (hasErrorItems) {
            setCreateLoading(false);
            setSubmitConfigVisible(false)
            message.error('存在未设置参考图的商品，请先设置参考图');
            return;
        }

        const startRes = await API.batchStartProject({
            projectId: projectId,
            num: projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? 1 : handleNumber,
            mode: generateMode,
            resolutionAlign: resolutionAlign,
            skinRefine: switchChecked ? 1 : 0,
            relight: relight,
        })
        setCreateLoading(false)
        if (startRes?.code === 0) {
            sessionStorage.removeItem('batchProductImagesPageIndex')
            message.success('项目发起成功')
            setSubmitConfigVisible(false)
            navigate(`/home/product/${projectId}/detail`)
        } else if (startRes?.code === -5012) {
            message.error('虹豆不足，请先购买会员')
            eventBus.emit('recharge')
        } else {
            message.error(startRes?.message)
        }
    }

    const editAndGenerate = async () => {
        const startRes = await API.editAndGenerate({
            ...dataSource[0],
            num: projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? 1 : handleNumber,
            mode: generateMode,
            resolutionAlign: resolutionAlign,
            skinRefine: switchChecked ? 1 : 0,
            relight: relight,
            projectId
        })
        if (startRes?.code === 0) {
            navigate(`/home/product/${projectId}/detail`)
        } else {
            message.error(startRes?.message)
        }
    }

    useEffect(() => {
        if (!dataSource || dataSource.length === 0) return;

        const totalLength = dataSource.reduce((sum, item) => {
            const bkgCount = item?.bkgList?.length || 0;
            const modelCount = projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? 0 : item?.modelList?.length;
            const refCount = item?.refList?.length || 0;
            return sum + bkgCount + modelCount + refCount;
        }, 0);

        setTotal(totalLength)
    }, [dataSource]);

    const Text1 = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '试衣参考图' :
            projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? '模特参考图' :
                projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '背景参考图' :
                    projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '辅品图' :
                        ''
    }, [projectType])
    const Text2 = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '添加商品图' :
            projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? '添加模特图' :
                projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '添加模特图' :
                    projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '添加主品图' :
                        ''
    }, [projectType])
    const Text3 = useMemo(() => {
        return projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? '个商品' :
            projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? '个模特' :
                projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? '个模特' :
                    projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? '个主品' :
                        ''
    }, [projectType])


    return (
        <div className={styles.FooterBar}>
            {
                uploading ?
                    <>
                        <div className={styles.FooterBarLeft}>
                            <Button disabled className={styles.BatchTrigger}>批量操作</Button>
                        </div>
                        <div className={styles.FooterBarRight}>
                            <div className={styles.BtnGroup}>
                                <Button style={{ width: 200, height: 36 }} disabled={true}>添加源素材</Button>
                                <Button style={{ width: 200, height: 36 }} type="primary" disabled={true}>帮我作图</Button>
                            </div>
                        </div>
                    </> :
                    <>
                        {
                            !isEdit ? <div className={styles.FooterBarLeft}>
                                {
                                    batchMode ?
                                        <Space>
                                            <Button disabled={selectedRowKeys?.length == 0} onClick={handleBatchSubmit} loading={loading} className={styles.BatchTrigger}>{items.find(item => item.key == batchMode).label}</Button>
                                            <Button danger className={styles.BatchTrigger} onClick={handleBatchExit}>退出操作</Button>
                                        </Space> :
                                        <Dropdown
                                            trigger={['click']}
                                            overlayClassName='BatchMenu'
                                            menu={{ items, onClick: handleBatchClick }}
                                            placement="top">
                                            <Button className={styles.BatchTrigger}>批量操作</Button>
                                        </Dropdown>
                                }
                            </div> : <span></span>
                        }
                        {
                            isEdit ? <div className={styles.FooterBarRight}>
                                <div className={styles.BtnGroup}>
                                    <div className={styles.SubmitBtn}>
                                        <Button style={{ width: 200, height: 36 }} type="primary" onClick={() => setSubmitConfigVisible(true)}>生成</Button>
                                    </div>
                                </div>
                            </div> : <div className={styles.FooterBarRight}>
                                <div className={styles.TaskInfo}>
                                    <span>{skuNumber}{Text3} · {total} 张{Text1}</span>
                                </div>
                                <div className={styles.BtnGroup}>
                                    <Button style={{ width: 200, height: 36 }} onClick={onAddMore}>{Text2}</Button>
                                    <div className={styles.SubmitBtn}>
                                        <Button style={{ width: 200, height: 36 }} type="primary" onClick={() => setSubmitConfigVisible(true)}>发起批量生成</Button>
                                    </div>
                                </div>
                            </div>
                        }
                    </>
            }
            <PSAIModal
                title='设置生图参数'
                maxWidth={564}
                okText={'确定'}
                open={submitConfigVisible}
                maskClosable={false}
                okButtonProps={{ disabled: false, loading: createLoading }}
                onCancel={() => setSubmitConfigVisible(false)}
                onOk={() => handleSubmitConfig()}
            >
                <div className={styles.submitConfigWrap}>
                    {
                        projectType !== BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH && <div className={styles.submitConfigItem}>
                            <span>每张参考图生成数量</span>
                            <p>{
                                Array.from({ length: 4 }).map((_, i) => <span className={handleNumber == i + 1 ? styles.active : ''} onClick={() => setHandleNumber(i + 1)} key={i}>{i + 1}张</span>)
                            }</p>
                        </div>
                    }
                    {
                        projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ? <div className={styles.submitConfigItem}>
                            <span>生成模式</span>
                            <div className={styles.PickerContent}>
                                {
                                    modeItems.map(item => (
                                        <div
                                            key={item.value}
                                            className={`${styles.PickerItem} ${item.isLimit && styles.isLimit} ${generateMode == item.value && styles.actived}`}
                                            onClick={() => setGenerateMode(item.value)}
                                        >
                                            <div className={styles.Title}>
                                                {generateMode == item.value ? item.iconActive : item.icon}
                                                <span>{item.title}</span>
                                            </div>
                                            <span className={styles.Content}>{item.content}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div> : projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? null : <>
                            <div className={styles.submitConfigItemModel}>
                                <div>
                                    <p>人像皮肤优化</p>
                                    <p>开启后人像肤质细节会更精致，但将增加生成时间</p>
                                </div>
                                <div><Switch style={{ marginRight: 8 }} checked={switchChecked} onChange={() => setSwitchChecked(!switchChecked)} />{switchChecked ? '开启' : '关闭'}</div>
                            </div>
                            <div className={styles.submitConfigItemModel}>
                                <div>
                                    <p>光影融合</p>
                                    <p>开启后光影融合细节会更精致，但将增加生成时间</p>
                                </div>
                                <div><Switch style={{ marginRight: 8 }} checked={switchChecked2} onChange={(v) => {
                                    setSwitchChecked2(v)
                                    setRelight(v ? 1.0 : 0.0)
                                }} />{switchChecked2 ? '开启' : '关闭'}</div>
                            </div>
                            {
                                relight > 0.0 && <div className={styles.SliderWrap}>
                                    <span>强度</span>
                                    <Slider className={styles.Slider} max={1.5} min={0.7} value={relight} step={0.1} onChange={value => setRelight(value)} />
                                    <span>{relight.toFixed(1)}</span>
                                </div>
                            }
                        </>
                    }
                    {
                        projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH && <div className={styles.submitConfigItem}>
                            <span>生成图比例</span>
                            <div className={styles.PickerContent}>
                                {
                                    resolutionAlignItems.map(item => (
                                        <div
                                            key={item.value}
                                            className={`${styles.PickerItem} ${resolutionAlign == item.value && styles.actived}`}
                                            onClick={() => setResolutionAlign(item.value)}
                                        >
                                            <div className={styles.Title}>
                                                <span>{item.title}</span>
                                            </div>
                                            <span style={{ marginTop: '8px' }} className={styles.Content}>{item.content}</span>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    }
                    {
                        projectType === BATCH_IMAGES_TYPE.COMMODITY_STACKING_BATCH ? <div className={styles.submitConfigBottom}>
                            <p>预计消耗<img style={{ margin: '0 12px', width: '32px', height: '32px' }} src={require('@assets/images/arcbean3.png')} alt="" />
                                <span className={styles.arcbean}>{dataSource.length * 40}</span></p>
                            <p>商品组合（主品）数 *40 虹豆</p>
                        </div> : <div className={styles.submitConfigBottom}>
                            <p>预计消耗<img style={{ margin: '0 12px', width: '32px', height: '32px' }} src={require('@assets/images/arcbean3.png')} alt="" />
                                <span className={styles.arcbean}>{total * handleNumber * (generateMode === GENERATE_MODE.STD ? 10 : 15)}</span></p>
                            <p>试衣参考图{total}张*每张参考图生成{handleNumber}张*{generateMode === GENERATE_MODE.STD ? '10' : '15'}虹豆</p>
                        </div>
                    }
                </div>
            </PSAIModal>
        </div>
    )
})

export default FooterBar
